export default __webpack_public_path__ + "static/media/logo-grip.fe3d1d31.svg";